module.exports = __webpack_public_path__ + "src/assets/img/card-face.e4e566af.svg";